export interface IEmailVerificationPayload {
    email: string;
    brand: string;
}

export const getStateToPayload = (email: string, brand: string): IEmailVerificationPayload => ({ email, brand });
